<div class="wrapper">
  <div class="image-wrapper hidden-sm-down">
    <img src="/assets/img/channels/widget_channels.png" class="widget-image">
  </div>
  <div class="text-wrapper">
    <h1 class="title-extension" translate="WIDGET.EXTENSION.TITLE"></h1>
    <h3 class="header-extension" translate="WIDGET.EXTENSION.HEADER"></h3>
    <h4 class="subheader-extension" translate="WIDGET.EXTENSION.BODY"></h4>
    <ul class="list-extension">
      <li>
        <span class="list-extension-item" translate="WIDGET.EXTENSION.SAVE_TIME"></span>
      </li>
      <li>
        <span class="list-extension-item" translate="WIDGET.EXTENSION.PLACE_CALL"></span>
      </li>
      <li>
        <span class="list-extension-item" translate="WIDGET.EXTENSION.GET_NOTIFICATION"></span>
      </li>
    </ul>
    <cc-download-widget></cc-download-widget>
  </div>
</div>
